module.exports = __webpack_public_path__ + "static/media/popupDelete.5e4fe669.svg";